app.controller('ReviewsSummaryCtrl', ['$scope', '$rootScope', 'reviewsByProduct', 'npsSummary', 'npsTrend', 'PageTitle', function($scope, $rootScope, reviewsByProduct, npsSummary, npsTrend, PageTitle) {
  PageTitle.set('Reviews - Supplier Hub | RedBalloon');

  $scope.reviewsByProduct = reviewsByProduct;
  $scope.npsSummary = npsSummary;
  $scope.npsTrend = npsTrend;
  $scope.fyOptions = $rootScope.financialYears; // set by 'parent' segment resolves

}]);
